
// compontents of logo
import { ReactComponent as STIM_Logo } from '../assets/logo_stim.svg';

function LogoSTIM() {
    return (
        <STIM_Logo />
    )
}

export default LogoSTIM;